import { ApplicationValueVersion } from 'app-zephyr-domains/application/application';

export function getLatestAppVersion(versions: ApplicationValueVersion[]) {
  return versions.length ? versions[0] : undefined;
}
